import { memo } from 'react';
import { Trip } from '../../Summary.model';
import { SummaryTrip } from '../summary-trip/SummaryTrip';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const SummaryTrips = memo(
	function SummaryTrips(props: { trips?: Trip[]; isMultiTrip: boolean; collapsed: boolean }) {
		const { trips, isMultiTrip, collapsed } = props;
		return (
			<ErrorBoundaryProvider>
				{trips?.map((trip, indexTrip) => {
					return (
						<SummaryTrip
							key={trip.id}
							trip={trip}
							indexTrip={indexTrip}
							isMultiTrip={isMultiTrip}
							collapsed={collapsed}
						></SummaryTrip>
					);
				})}
			</ErrorBoundaryProvider>
		);
	},
	(prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);
SummaryTrips.displayName = 'SummaryTrips';
